import { AnimatePresence, motion } from "motion/react";

type CountBadgeProps = {
  learningCount: number;
  knownCount: number;
  swipeDirection: "left" | "right" | null;
};

export function CountBadge({ learningCount, knownCount, swipeDirection }: CountBadgeProps) {
  return (
    <div className="flex justify-between px-5">
      {/* 학습 카운트 배지 */}
      <div className="relative">
        <div className="flex items-center justify-center gap-1.5 rounded-lg bg-orange-50 px-4 py-1.5 w-15.5">
          <span className="text-sm font-black text-orange-500">{learningCount}</span>
        </div>
        <AnimatePresence>
          {swipeDirection === "left" && (
            <motion.span
              key="left-plus"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1, transition: { duration: 0.15 } }}
              exit={{ opacity: 0, transition: { duration: 0.15 } }}
              className="absolute bottom-0 left-1/2 -translate-x-1/2 text-sm font-black bg-orange-400 text-orange-50 px-4 py-1.5 rounded-lg w-15.5 flex items-center justify-center"
            >
              +1
            </motion.span>
          )}
        </AnimatePresence>
      </div>

      {/* 알고 있음 카운트 배지 */}
      <div className="relative">
        <div className="flex items-center justify-center gap-1.5 rounded-lg bg-emerald-50 px-4 py-1.5 w-15.5">
          <span className="text-sm font-black text-emerald-500">{knownCount}</span>
        </div>
        <AnimatePresence>
          {swipeDirection === "right" && (
            <motion.span
              key="right-plus"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1, transition: { duration: 0.15 } }}
              exit={{ opacity: 0, transition: { duration: 0.15 } }}
              className="absolute bottom-0 left-1/2 -translate-x-1/2 text-sm font-black bg-emerald-500 text-emerald-50 px-4 py-1.5 rounded-lg w-15.5 flex items-center justify-center"
            >
              +1
            </motion.span>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
}
